import { useParams, NavLink, Navigate } from "react-router";
import { DOCS, getDoc } from "../lib/docs-registry";
import { DocView } from "../components/DocView";

export function Docs() {
  const { slug } = useParams<{ slug: string }>();

  // /docs with no slug → land on the first guide (guard an empty registry).
  if (!slug) {
    const first = DOCS[0];
    if (!first) return <p className="page-help">No documentation configured.</p>;
    return <Navigate to={`/docs/${first.slug}`} replace />;
  }

  const doc = getDoc(slug);

  return (
    <div className="docs">
      <nav className="docs__nav" aria-label="Documentation">
        <div className="uppercase-label" style={{ padding: "0 var(--space-4) var(--space-2)" }}>
          DOCUMENTATION
        </div>
        {DOCS.map((d) => (
          <NavLink
            key={d.slug}
            to={`/docs/${d.slug}`}
            className={({ isActive }) => `docs__nav-link${isActive ? " docs__nav-link--active" : ""}`}
          >
            {d.title}
          </NavLink>
        ))}
      </nav>
      <div className="docs__content">
        {doc ? (
          <DocView content={doc.content} sourcePath={doc.sourcePath} />
        ) : (
          <p className="page-help">No such document.</p>
        )}
      </div>
    </div>
  );
}
